import React, { useEffect } from 'react';

const VideoModal = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: VideoModal is not implemented yet.');
  }, []);
  return (
    <>
  { /*VideoModal */} 
 </>
  );
};

export default VideoModal;
